export default __webpack_public_path__ + "static/media/dashboardStatsIcon.b7655f37.svg";